<template>
    <v-container class="my-5">
        <v-layout row wrap class="justify-center">
            <v-flex xs12>
                <v-card-title>
                    <v-btn icon @click="$router.go(-1)" class="mr-3">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    {{ $t('golf_caddies') }}
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialog = true">
                        + {{ $t('add_caddie') }}
                    </v-btn>
                </v-card-title>

                <v-data-table :headers="headers" :items="caddies" :loading="loading" class="elevation-1"
                    :no-data-text="$t('no_records_yet')">
                    <template v-slot:item.caddie_type="{ item }">
                        {{ getCaddieTypeName(item.caddie_type) }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="viewDetails(item)">
                                    mdi-eye
                                </v-icon>
                            </template>
                            <span>{{ $t('view_details') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">
                                    mdi-pencil
                                </v-icon>
                            </template>
                            <span>{{ $t('edit') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon small v-bind="attrs" v-on="on" @click="confirmDelete(item)">
                                    mdi-delete
                                </v-icon>
                            </template>
                            <span>{{ $t('delete_action') }}</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>

        <!-- Dialog para crear o editar un caddie -->
        <v-dialog v-model="dialog" max-width="500px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field v-model="editedItem.name" :label="$t('caddie_name')"
                                        :rules="[rules.required]"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-select v-model="editedItem.caddie_type" :items="caddieTypes" item-text="text"
                                        item-value="value" label="Tipo" :rules="[rules.required]"></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">{{ $t('cancelar') }}</v-btn>
                    <v-btn color="blue darken-1" text @click="save" :disabled="!valid">{{ $t('guardar') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog for Details -->
        <v-dialog v-model="dialogDetails" max-width="600px">
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    {{ $t('caddie_details') }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogDetails = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pt-4">
                    <v-list dense>
                        <v-list-item>
                            <v-list-item-content><strong>{{ $t('nombre') }}:</strong></v-list-item-content>
                            <v-list-item-content class="align-end">{{ viewItem.name }}</v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content><strong>Tipo:</strong></v-list-item-content>
                            <v-list-item-content class="align-end">{{ getCaddieTypeName(viewItem.caddie_type)
                                }}</v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content><strong>ID:</strong></v-list-item-content>
                            <v-list-item-content class="align-end">{{ viewItem.id }}</v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Delete Confirmation Dialog -->
        <v-dialog v-model="dialogDelete" max-width="400px">
            <v-card>
                <v-card-title class="headline">{{ $t('delete_caddie_title') }}</v-card-title>
                <v-card-text>{{ $t('delete_caddie_confirm') }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">{{ $t('cancelar') }}</v-btn>
                    <v-btn color="red darken-1" text @click="deleteItemConfirm">{{ $t('delete_action') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'

const API_BASE_URL = 'https://clubtest.intrare.app'

export default {
  name: 'GolfCaddies',
  data: () => ({
    dialog: false,
    dialogDetails: false,
    dialogDelete: false,
    loading: false,
    valid: true,
    itemToDelete: null,
    caddies: [],
    editedIndex: -1,
    editedItem: {
      name: '',
      caddie_type: null
    },
    defaultItem: {
      name: '',
      caddie_type: null
    },
    viewItem: {}
  }),

  computed: {
    caddieTypes () {
      return [
        { value: 1, text: this.$t('caddie_type_first') },
        { value: 2, text: this.$t('caddie_type_second') },
        { value: 3, text: this.$t('caddie_type_bag') }
      ]
    },
    formTitle () {
      return this.editedIndex === -1 ? this.$t('new_caddie') : this.$t('edit_caddie')
    },
    headers () {
      return [
        { text: 'ID', value: 'id' },
        { text: this.$t('nombre'), value: 'name' },
        { text: 'Tipo', value: 'caddie_type' },
        { text: this.$t('acciones'), value: 'actions', sortable: false }
      ]
    },
    rules () {
      return {
        required: value => !!value || this.$t('required_field')
      }
    }
  },

  created () {
    this.initializeComponent()
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    }
  },

  methods: {

    async initializeComponent () {
      await this.getCaddies()
    },

    async getCaddies () {
      this.loading = true
      try {
        const response = await this.apiCall('get', '/caddies/')
        console.log(response.data)
        this.caddies = response.data
      } catch (error) {
        console.error('Error fetching caddies:', error)
      } finally {
        this.loading = false
      }
    },

    apiCall (method, endpoint, data = null) {
      const config = {
        method,
        url: `${API_BASE_URL}${endpoint}`,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }

      if (data) {
        config.data = data
      }

      return axios(config)
    },

    editItem (item) {
      this.editedIndex = this.caddies.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    viewDetails (item) {
      this.viewItem = Object.assign({}, item)
      this.dialogDetails = true
    },

    confirmDelete (item) {
      this.itemToDelete = item
      this.dialogDelete = true
    },

    async deleteItemConfirm () {
      if (this.itemToDelete) {
        this.loading = true
        try {
          await this.apiCall('delete', `/caddies/${this.itemToDelete.id}/`)
          const index = this.caddies.indexOf(this.itemToDelete)
          this.caddies.splice(index, 1)
        } catch (error) {
          console.error('Error deleting caddie:', error)
        } finally {
          this.loading = false
          this.closeDelete()
        }
      }
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.itemToDelete = null
      })
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.$refs.form.resetValidation()
      })
    },

    async save () {
      if (!this.$refs.form.validate()) return

      this.loading = true
      try {
        if (this.editedIndex > -1) {
          // Editar
          const response = await this.apiCall('put', `/caddies/${this.editedItem.id}/`, this.editedItem)
          Object.assign(this.caddies[this.editedIndex], response.data)
        } else {
          // Crear
          const response = await this.apiCall('post', '/caddies/', this.editedItem)
          this.caddies.push(response.data)
        }
        this.close()
      } catch (error) {
        console.error('Error saving caddie:', error)
      } finally {
        this.loading = false
      }
    },

    getCaddieTypeName (typeId) {
      const type = this.caddieTypes.find(t => t.value === typeId)
      return type ? type.text : ''
    }
  }
}
</script>
